import React from 'react';

export const ExpertiseIcon = (): JSX.Element => (
    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="20" height="22">
        <path d="M17.999 21.389l-3.12-3.069c-1.468.913-3.33.906-4.792-.017-2.105-1.331-2.733-4.116-1.403-6.222 1.331-2.106 4.116-2.734 6.222-1.403 2.106 1.33 2.734 4.116 1.403 6.221l3.081 3.1-1.391 1.39zm-5.5-9.39c-1.38 0-2.5 1.12-2.5 2.5 0 1.381 1.12 2.5 2.5 2.5 1.381 0 2.5-1.119 2.5-2.5 0-1.38-1.119-2.5-2.5-2.5zm-5.5 6c.247.397.535.766.861 1.1.342.345.725.647 1.139.9h-7c-1.105 0-2-.895-2-2V2c0-1.105.895-2.001 2-2.001h8l6 6v3c-.614-.387-1.291-.664-2-.82v-1.18h-5V2h-7v15.999h5z" />
    </svg>
);
